// purely.: valget mellom engangskjøp og abonnement (snippets/purely-kjopsmate.liquid).
// Engangskjøp: pakkekortene virker som før. Abonnement: «1 pakke per levering» sender selling_plan med skjemaet,
// og «Start med 3 pakker» legger to engangspakker og abonnementet i kurven i ett kall (data-purely-linjer,
// lest av assets/product-form.js). Kjøp 2 få 1 gjør da én engangspakke gratis.
(() => {
  if (customElements.get('purely-kjopsmate')) return;

  const kr = (ore) => `${(ore / 100).toLocaleString('nb-NO', { maximumFractionDigits: 2 })} kr`;
  const vask = (t) => String(t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  class PurelyKjopsmate extends HTMLElement {
    connectedCallback() {
      this.skjema = document.getElementById(this.dataset.skjema);
      this.variant = Number(this.dataset.variant);
      this.engangspris = Number(this.dataset.engangspris);
      this.tekster = JSON.parse(this.querySelector('[data-tekster]').textContent);
      this.plan = this.querySelector('[data-plan]');
      this.levering = this.querySelector('[data-levering]');
      this.sellingPlan = this.querySelector('[data-selling-plan]');
      this.pakker = this.parentElement.querySelector('[data-purely-pakker]');
      this.vilkar = this.skjema && this.skjema.querySelector('[data-purely-abo-vilkar]');
      if (!this.skjema || !this.pakker) return;
      this.kort = [...this.pakker.querySelectorAll('input[type="radio"]')].map((input) => {
        const label = this.pakker.querySelector(`label[for="${input.id}"]`);
        return { input, label, html: label.innerHTML, pris: input.dataset.pris };
      });
      this.addEventListener('change', () => this.oppdater());
      this.pakker.addEventListener('change', () => this.oppdater());
      this.oppdater();
    }

    get abonnement() {
      return this.querySelector('input[value="abonnement"]').checked;
    }

    oppdater() {
      if (this.oppdaterer) return;
      this.oppdaterer = true;
      const abo = this.abonnement;
      const valg = this.plan.selectedOptions[0];
      const aboPris = Number(valg.dataset.pris);
      const hyppighet = valg.dataset.hyppighet;
      const startPris = this.engangspris + aboPris;
      this.levering.hidden = !abo;

      for (const k of this.kort) {
        const n = Number(k.input.dataset.antall);
        if (!abo) {
          k.label.innerHTML = k.html;
          k.input.dataset.pris = k.pris;
          k.label.hidden = false;
          k.input.disabled = false;
          continue;
        }
        if (n === 2) {
          // To pakker gir ingen gratisvare i abonnement, så valget skjules
          k.label.hidden = true;
          k.input.disabled = true;
          if (k.input.checked) this.kort[0].input.checked = true;
          continue;
        }
        k.label.hidden = false;
        k.input.disabled = false;
        const navn = n === 1 ? '1 pakke per levering' : 'Start med 3 pakker';
        const gave = n === 1 ? `${kr(aboPris)} ${hyppighet}, fri frakt` : `${this.tekster.kampanje}, så ${kr(aboPris)} ${hyppighet} med fri frakt`;
        const pris = n === 1 ? aboPris : startPris;
        k.input.dataset.pris = pris;
        k.label.innerHTML =
          '<span class="purely-pakke__prikk" aria-hidden="true"></span>' +
          `<span class="purely-pakke__tekst"><span class="purely-pakke__navn">${vask(navn)}</span><span class="purely-pakke__gave">${vask(gave)}</span></span>` +
          `<span class="purely-pakke__pris" data-sticky-pris>${vask(kr(pris))}</span>`;
      }

      const valgt = this.pakker.querySelector('input[type="radio"]:checked');
      const antall = Number((valgt && valgt.dataset.antall) || 1);
      if (abo && antall === 3) {
        this.skjema.dataset.purelyLinjer = JSON.stringify([
          { id: this.variant, quantity: 2 },
          { id: this.variant, quantity: 1, selling_plan: Number(this.plan.value) },
        ]);
        this.sellingPlan.disabled = true;
        this.sellingPlan.value = '';
      } else {
        delete this.skjema.dataset.purelyLinjer;
        this.sellingPlan.disabled = !abo;
        this.sellingPlan.value = abo ? this.plan.value : '';
      }

      if (this.vilkar) {
        this.vilkar.hidden = !abo;
        if (abo) {
          const start = antall === 3 ? `Første bestilling er 3 pakker for ${kr(startPris)}. ` : '';
          this.vilkar.innerHTML =
            `${vask(start)}Deretter ${vask(kr(aboPris))} ${vask(hyppighet)} med fri frakt, og du kan stoppe når du vil. ` +
            'Du kan pause, hoppe over en levering eller si opp på kontosiden din. ' +
            `<a href="${vask(this.tekster.vilkarUrl)}">Vilkår for abonnement</a>`;
        }
      }

      // Den faste kjøpslinja leser prisen fra det valgte kortet når noe endres
      if (valgt) valgt.dispatchEvent(new Event('change', { bubbles: true }));
      this.oppdaterer = false;
    }
  }

  customElements.define('purely-kjopsmate', PurelyKjopsmate);
})();
